export default {"src":"/_next/static/media/fr.7fcdb1ef.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};